import { currencyFormat } from '@/utilities/CommonUtils';
import { Text } from '@/components/Text/Text';
import { useAppSelector } from '@/store/hooks';
import {
  getStoreCartDesignGroupApiStatus,
  hasStoreCartDesignGroupQuoteFailed,
  isStoreCartDesignGroupQuotePending,
  shouldShowStoreCartDesignGroupPrice,
} from '@/modules/Cart/StoreCart/helpers/storeCartSetup.utils';
import { STORE_CART_PRICE_LOADING_ARIA_LABEL } from '@/modules/Cart/StoreCart/storeCart.constants';

interface IStoreCartGroupPriceDisplayProps {
  groupKey: string;
  price: number;
  className?: string;
  priceClassName?: string;
  labelClassName?: string;
  shimmerClassName?: string;
  showPerItemLabel?: boolean;
  /** When true, show the item price even if the design-group quote is not ready. */
  isBlockedForCheckout?: boolean;
}

const StoreCartGroupPriceDisplay: React.FC<IStoreCartGroupPriceDisplayProps> = ({
  groupKey,
  price,
  className,
  priceClassName,
  labelClassName,
  shimmerClassName,
  showPerItemLabel = false,
  isBlockedForCheckout = false,
}) => {
  const designGroupApiStatusByKey = useAppSelector(
    (state) => state.storeCart.designGroupApiStatusByKey
  );
  const status = getStoreCartDesignGroupApiStatus(designGroupApiStatusByKey, groupKey);

  if (
    !isBlockedForCheckout &&
    (isStoreCartDesignGroupQuotePending(status) ||
      hasStoreCartDesignGroupQuoteFailed(status) ||
      !shouldShowStoreCartDesignGroupPrice(status) ||
      !(price > 0))
  ) {
    return (
      <span className={className} aria-busy="true" aria-label={STORE_CART_PRICE_LOADING_ARIA_LABEL}>
        <span className={shimmerClassName} aria-hidden="true" />
      </span>
    );
  }

  return (
    <Text as="span" className={priceClassName ?? className}>
      {currencyFormat(price)}
      {showPerItemLabel && labelClassName ? <span className={labelClassName}> / Item</span> : null}
    </Text>
  );
};

StoreCartGroupPriceDisplay.displayName = 'StoreCartGroupPriceDisplay';

export default StoreCartGroupPriceDisplay;
